/******************************** Import Package ************************************/
import React from "react"
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { styled } from "@mui/material/styles";

/******************************** Notification style ************************************/
const RootSnackbar = styled(Snackbar)(({ theme }) => ({
  top: theme.spacing(9)
}));

/******************************** Notification  ************************************/
export default function Notification({ notify, setNotify }) {

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNotify({ ...notify, isOpen: false });
  };

  return (
    <RootSnackbar
      open={notify.isOpen}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleClose}
    >
      <Alert
        severity={notify.type}
        onClose={handleClose}
        variant="filled"
      >
        {notify.message}
      </Alert>
    </RootSnackbar>
  );
}
